import { Check, SwapHoriz } from '@mui/icons-material';
import * as S from './RelatedProfileSwitcher.styled';

interface RelatedProfileSwitcherProps {
    name: string;
    relationship: string;
    active: boolean;
    activeLabel: string;
    actionLabel: string;
    onToggle: () => void;
}

const getInitials = (name: string) => {
    const initials = name
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0]?.toUpperCase())
        .join('');

    return initials || '—';
};

const RelatedProfileSwitcher = ({
    name,
    relationship,
    active,
    activeLabel,
    actionLabel,
    onToggle,
}: RelatedProfileSwitcherProps) => {
    return (
        <S.ProfileButton
            type="button"
            active={active}
            aria-pressed={active}
            aria-label={`${actionLabel}: ${name}, ${relationship}`}
            title={actionLabel}
            onClick={onToggle}
        >
            <S.SwitchIcon aria-hidden="true">
                <SwapHoriz fontSize="small" />
            </S.SwitchIcon>
            <S.Avatar active={active}>{getInitials(name)}</S.Avatar>
            <S.ProfileText>
                <S.Relationship>{relationship}</S.Relationship>
                <S.Name title={name}>{name}</S.Name>
            </S.ProfileText>
            <S.ActiveIndicator
                active={active}
                aria-label={active ? activeLabel : undefined}
                aria-hidden={!active}
            >
                {active && <Check sx={{ fontSize: 14 }} />}
            </S.ActiveIndicator>
        </S.ProfileButton>
    );
};

export default RelatedProfileSwitcher;
